module.exports = __webpack_public_path__ + "img/头图.3b776d9b.jpg";